import Analytics from "analytics";
import mixpanelPlugin from "@analytics/mixpanel";
import ENV from "./env";

const analyticsInstance = Analytics({
  app: "BTFDCA",
  plugins: [
    mixpanelPlugin({
      token: ENV.MIXPANEL_PROJECT_TOKEN,
      options: {
        debug: true,
      },
    }),
  ],
});

export default analyticsInstance;
